<template>
  <div class="tree-content">
    <div class="filter-inline-panel cle">
      <el-form :inline="true" size="mini" :model="filters" class="filter-panel"></el-form>
      <div class="list-opinion fr">
        <el-button type="primary" size="mini" @click="add()"  v-if="hasBtn('add')">{{$t('index.add')}}</el-button>
      </div>
    </div>
    <el-table :data="list" border row-key="id" size="mini" :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
      <el-table-column :prop="lang=='cn'?'name_cn':'name'" align="center" :label="$t('dictionary.list_name')"></el-table-column>
      <el-table-column prop="code" align="center" :label="$t('dictionary.list_code')"></el-table-column>
      <el-table-column :label="$t('index.operation')" align="center">
        <template slot-scope="scope">
          <el-button size="mini" type="primary" v-if="hasBtn('edit')" @click="add(scope.row)">{{$t('index.edit')}}</el-button>
          <el-button size="mini" type="danger" v-if="hasBtn('del')" @click="del(scope.row)">{{$t('index.del')}}</el-button>
          <el-button size="mini" type="primary" v-if="hasBtn('sub_list')" @click="router_url('/system_data_dictionary_list',{id:scope.row.id})">{{$t('dictionary.subset_list')}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="page-pagination" >
		<el-pagination align="right" small background :hide-on-single-page="false" @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages.page" :page-sizes="[10, 20, 30, 40, 50, 100]" :page-size="pages.perpage" layout="total, prev, pager, next, sizes, jumper" :total="pages.count" :pagerCount="5"></el-pagination>
    </div>
    <el-dialog :title="$t('index.dialog_title')" width="700px" :close-on-click-modal="false" :visible="editFormVisible" @close="editFormVisible = false">
      <el-row class="tree-content" :gutter="20">
        <el-form :model="editForm" size="mini" label-width="80px" label-position="top" :rules="editFormRules" ref="editForm">
          <el-col :span="12">
            <el-form-item :label="$t('index.cn')+$t('dictionary.name')" prop="name_cn">
              <el-input v-model="editForm.name_cn" class="w100" :placeholder="$t('index.pleaseInput')" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('index.en')+$t('dictionary.name')" prop="name">
              <el-input v-model="editForm.name" class="w100" :placeholder="$t('index.pleaseInput')" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('dictionary.list_code')" prop="code">
              <el-input v-model="editForm.code" class="w100" :placeholder="$t('index.pleaseInput')" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click.native="editFormVisible = false">{{$t('index.cancel')}}</el-button>
        <el-button size="mini" type="primary" @click.native="editSubmit('editForm')">{{$t('index.submit')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
	computed: {
		editFormRules(){
			return{
				name_cn: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('index.cn')+this.$t('dictionary.name'),
					trigger: 'blur'
				}],
				name: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('index.en')+this.$t('dictionary.name'),
					trigger: 'blur'
				}],
				code: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('dictionary.list_code'),
					trigger: 'blur'
				}],
			}
		},
	},
	data() {
		return {
			list: [],
			editFormVisible: false,
			editForm: {
				name: '',
				name_cn: '',
				code: '',
			},
			filters: {},
			pages: {
				page: 1,
				count: 100,
				perpage: 20,
			},
		}
	},
	// 初始事件
	mounted: function () {
		this.init();
	},
	// 事件
	methods: {
		// 初始化
		init() {
			var this_ = this;
			var url = "dictionaryList";
			var datas = {
				page:this_.pages.page,
				num:this_.pages.perpage,
			};
			this_.$post(url, datas).then((res) => {
				this_.list = res.list;
				this_.pages.count=res.sum;

			})
		},
		add(data) {
			if (data) {
				this.editForm = JSON.parse(JSON.stringify(data));
			} else {
				this.editForm = {
					name: '',
					name_cn: '',
					code: '',
				}
			}
			if (this.$refs.editForm) {
				this.$refs.editForm.resetFields();
			}
			this.editFormVisible = true;
		},
		// 保存
		editSubmit(editForm) {
			var this_ = this;
			this_.$refs.editForm.validate((valid) => {
				if (valid) {
					var datas = {
						name_cn: this_.editForm.name_cn,
						name: this_.editForm.name,
						code: this_.editForm.code,
					}
					var url = "addDictionary";
					var tishi = this_.$t('index.add_success');
					if (this_.editForm.id) {
						datas['id'] = this_.editForm.id;
						tishi = this_.$t('index.modify_success');
						url = "editDictionary";
					}
					this_.$post(url, datas).then((res) => {
						this_.$message.success(tishi);
						this_.editFormVisible = false;
						this_.init();
					});
				} else {
					return false;
				}
			})
		},
		// 删除
		del(data) {
			var this_ = this;
			var url = "deleteDictionary";
			var datas = {
				id: data.id
			};
			this_.$confirm(this_.$t('index.confirm_delete'), this_.$t('index.tips')).then(() => {
				this_.$post(url, datas).then((res) => {
					this_.$message.success(this_.$t('index.delete_success'));
					this_.init();
				})
			}).catch(() => {});
		},
		// 分页每页显示几条
		handleSizeChange(val) {
			var pages = this.pages;
			pages['perpage'] = val;
			this.pages = pages;
			this.init();
		},
		// 切换分页
		handleCurrentChange(val) {
			var pages = this.pages;
			pages['page'] = val;
			this.pages = pages;
			this.init();
		}
	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
.filter-inline-panel {
	margin-bottom: 22px;
}
.page-pagination {
	padding: 20px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/system/data_dictionary.vue